/* unplugin-vue-components disabled */import { render } from "./ComicsItem.vue?vue&type=template&id=a9b9c138&scoped=true"
import script from "./ComicsItem.vue?vue&type=script&lang=js"
export * from "./ComicsItem.vue?vue&type=script&lang=js"

import "./ComicsItem.vue?vue&type=style&index=0&id=a9b9c138&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b9c138"]])

export default __exports__